import * as React from 'react';
import { observer } from 'mobx-react';
import { Textfit } from 'react-textfit';
import { TextFormat } from '@sprinklr/stories/widget/types';
import { LINE_CLAMP_STYLES } from '@sprinklr/display-builder/constants';
import './PostTitle.scss';

interface PostTitleProps {
    children: React.ReactNode;
    classes?: string;
    format: TextFormat;
}

const PostTitle: React.FC<PostTitleProps> = ({ children, classes, format }): React.ReactElement => {
    return (
        <div
            className={`post_title_container no-grow format_${format.type} flex ${
                classes ? classes : ''
            }`}>
            {format.type === 'clamp' && (
                <div style={LINE_CLAMP_STYLES} className={`post_title clamp-${format.clamp.lines}`}>
                    {children}
                </div>
            )}
            {format.type === 'fit' && (
                <Textfit className='post_title flex' min={format.fit.min} max={format.fit.max}>
                    {children}
                </Textfit>
            )}
        </div>
    );
};

PostTitle.displayName = 'PostTitle';
export default observer(PostTitle);
